// Jade Espada — media action buttons (snippets/je-media-actions.liquid).
// A button shows its panel over the product's main image; the close chip,
// a second click or a thumbnail click returns to the product photo.
// Delegated on document so it keeps working after theme-editor re-renders.

const panelFor = (id) => document.querySelector(`[data-je-panel="${id}"]`);

function hideAll(scope) {
  scope.querySelectorAll('[data-je-panel]').forEach((panel) => {
    panel.hidden = true;
    panel.classList.remove('is-open');
    panel.querySelector('video')?.pause();
  });
  scope.querySelectorAll('[data-je-act]').forEach((btn) => {
    btn.classList.remove('is-active');
    btn.setAttribute('aria-pressed', 'false');
  });
}

function show(btn) {
  const panel = panelFor(btn.dataset.jeAct);
  if (!panel) return;
  const scope = btn.closest('.shopify-section') || document;
  const wasOpen = btn.classList.contains('is-active');
  hideAll(scope);
  if (wasOpen) return;

  panel.hidden = false;
  void panel.offsetWidth; // commit the unhidden state so the fade-in transition runs
  panel.classList.add('is-open');
  btn.classList.add('is-active');
  btn.setAttribute('aria-pressed', 'true');

  const video = panel.querySelector('video');
  if (video) {
    video.muted = true;
    video.play().catch(() => {});
  }

  const rect = panel.getBoundingClientRect();
  if (rect.top < 0 || rect.bottom > window.innerHeight) {
    panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

if (!window.__jeMediaActions) {
  window.__jeMediaActions = true;

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-je-act]');
    if (btn) return show(btn);

    const close = event.target.closest('[data-je-close]');
    if (close) return hideAll(close.closest('.shopify-section') || document);

    const thumb = event.target.closest('[data-psh-thumb], [data-pis-thumb]');
    if (thumb) hideAll(thumb.closest('.shopify-section') || document);
  });

  document.addEventListener('input', (event) => {
    const range = event.target.closest('.je-compare__range');
    if (range) range.closest('[data-je-compare]').style.setProperty('--pos', `${range.value}%`);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('[data-je-panel].is-open');
    if (open) hideAll(open.closest('.shopify-section') || document);
  });
}
